import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '41798941692';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const ChatWidget = () => {
  const location = useLocation();

  if (location.pathname === '/admin') return null;

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-xl hover:bg-[#1ebe57] transition-all hover:scale-110"
      aria-label="Contacter sur WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.129 6.742 3.047 9.379L1.054 31.27l6.1-1.957A15.906 15.906 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.32 22.609c-.39 1.1-1.932 2.013-3.172 2.28-.848.18-1.955.324-5.684-1.222-4.773-1.977-7.843-6.82-8.082-7.137-.228-.317-1.932-2.574-1.932-4.908s1.222-3.48 1.656-3.957c.434-.478.95-.597 1.265-.597.317 0 .633.003.91.016.292.014.683-.11 1.069.815.39.94 1.33 3.25 1.448 3.487.118.237.197.513.04.83-.158.316-.237.513-.474.79-.237.278-.498.62-.712.832-.237.237-.484.494-.208.968.277.475 1.23 2.03 2.642 3.29 1.814 1.62 3.343 2.122 3.818 2.36.474.236.752.197 1.028-.119.277-.317 1.188-1.384 1.504-1.862.317-.475.633-.396 1.069-.237.434.158 2.77 1.306 3.245 1.543.474.237.79.356.91.554.117.198.117 1.147-.274 2.253z"/>
      </svg>
    </a>
  );
};

export default ChatWidget;
